import { GET_CONCRETE_CLASSES_STATISTICAL_REQUEST } from './types';

const getConcreteClassesStatistical = (payload) => ({
  type: GET_CONCRETE_CLASSES_STATISTICAL_REQUEST,
  payload,
});

export { getConcreteClassesStatistical };
